import axios from 'axios';

// Base URL for the backend.
// A production build (yarn build) ALWAYS calls the API at the relative "/api"
// path — the frontend and the PHP API are served from the same domain on
// Hostinger. This is forced here because REACT_APP_BACKEND_URL may be set in the
// build environment (e.g. an Emergent/CI shell) to a preview URL, and an empty
// value in .env.production does NOT override an already-set env var.
// REACT_APP_BACKEND_URL is honoured only for local development.
const BACKEND_URL =
  process.env.NODE_ENV === 'production'
    ? ''
    : (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = 'cf_token';

const api = axios.create({ baseURL: API });

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common['Authorization'];
  }
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

const existing = getToken();
if (existing) api.defaults.headers.common['Authorization'] = `Bearer ${existing}`;

export function apiErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(' ');
  if (detail.msg) return detail.msg;
  return String(detail);
}

// Resolves a media URL for rendering. Backend-served files are stored as
// relative "/api/..." paths so they work regardless of which domain the
// frontend is hosted on (e.g. Hostinger) by prefixing the backend URL.
export function mediaUrl(u) {
  if (!u) return u;
  if (u.startsWith('/api/')) return `${BACKEND_URL}${u}`;
  return u;
}

// Guarantees an array. Protects the UI from a misconfigured/unreachable backend
// that returns a non-array (e.g. an HTML string or an object) instead of JSON.
export function asArray(x) {
  return Array.isArray(x) ? x : [];
}

export default api;
